import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';
import img_pages_products_custom_icon_1 from '@/assets/svg/pages-products-custom-icon-1.svg';
import img_pages_products_custom_icon_2 from '@/assets/svg/pages-products-custom-icon-2.svg';
import img_pages_products_custom_icon_3 from '@/assets/svg/pages-products-custom-icon-3.svg';
import img_pages_products_custom_icon_4 from '@/assets/svg/pages-products-custom-icon-4.svg';
import img_pages_products_custom_icon_5 from '@/assets/svg/pages-products-custom-icon-5.svg';

const ADVANTAGES = [
  {
    icon: img_pages_products_custom_icon_4,
    title: 'All Wood Species Available',
    description:
      'We can produce flooring using a wide range of hardwood species including oak, walnut, maple, teak, ash, and many others.',
  },
  {
    icon: img_pages_products_custom_icon_2,
    title: 'Custom Specifications',
    description:
      'We manufacture flooring based on your exact requirements: thickness, width, length, surface treatment, color, and finish.',
  },
  {
    icon: img_pages_products_custom_icon_5,
    title: 'Consistent Quality Control',
    description:
      'Our production process ensures durability, precision milling, and stable flooring suitable for long-term performance.',
  },
  {
    icon: img_pages_products_custom_icon_3,
    title: 'Competitive Pricing For Bulk Orders',
    description: 'Ideal for wholesalers, flooring distributors, builders, and large projects.',
  },
  {
    icon: img_pages_products_custom_icon_1,
    title: 'Reliable Production Lead Time',
    description: 'Efficient manufacturing allows us to deliver orders on schedule.',
  },
];

const Custom = () => {
  return (
    <div className={styles['custom-page']}>
      <div className={styles.page}>
        <section className={styles['custom-hero']}>
          <div className={styles['custom-hero__overlay']}>
            <SiteTopNav />
            <div className={styles['custom-hero__content']}>
              <h1 className={styles['custom-hero__title']} data-motion="hero">
                Custom Flooring
              </h1>
              <p className={styles['custom-hero__lead']} data-motion="copy">
                We specialize in manufacturing high-quality custom hardwood flooring for
                distributors, contractors, designers, and developers. With flexible production
                capabilities, we can produce flooring from virtually any wood species to meet your
                project&apos;s design, performance, and budget requirements.
              </p>
              <p className={styles['custom-hero__lead']} data-motion="copy">
                Whether you are sourcing flooring for residential homes, commercial spaces, or large
                development projects, we deliver consistent quality, reliable lead times, and
                competitive pricing.
              </p>
            </div>
          </div>
        </section>

        <main>
          <section
            className={styles['custom-advantages']}
            aria-labelledby="custom-advantages-title"
          >
            <h2
              id="custom-advantages-title"
              className={styles['custom-advantages__title']}
              data-motion="title"
            >
              Why Choose Us
            </h2>
            <div className={styles['custom-advantages__grid']}>
              {ADVANTAGES.map(item => (
                <article key={item.title} className={styles['advantage-card']} data-motion="card">
                  <img
                    className={styles['advantage-card__icon']}
                    alt=""
                    referrerPolicy="no-referrer"
                    src={item.icon}
                  />
                  <h3 className={styles['advantage-card__title']}>{item.title}</h3>
                  <p className={styles['advantage-card__description']}>{item.description}</p>
                </article>
              ))}
            </div>
          </section>

          <section className={styles['custom-contact-hero']}>
            <div className={styles['custom-contact-hero__overlay']}>
              <div className={styles['custom-contact-hero__content']}>
                <h2 className={styles['custom-contact-hero__title']} data-motion="title">
                  Contact Us
                </h2>
                <p className={styles['custom-contact-hero__lead']} data-motion="copy">
                  We welcome inquiries from flooring distributors, importers, contractors, and
                  project developers.
                </p>
              </div>
            </div>
          </section>

          <section
            className={styles['custom-contact-info']}
            aria-label="Contact information"
            data-motion="section"
          >
            <div className={styles['custom-contact-info__item']} data-motion="card-soft">
              <span className={styles['custom-contact-info__label']}>Email</span>
              <a
                className={styles['custom-contact-info__value']}
                href="mailto:info@sakurafloors.com"
              >
                info@sakurafloors.com
              </a>
            </div>
            <div className={styles['custom-contact-info__item']} data-motion="card-soft">
              <span className={styles['custom-contact-info__label']}>Location</span>
              <address className={styles['custom-contact-info__value']}>
                PO BOX 241, Brentwood,
                <br />
                CA 94513
              </address>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Custom;
